var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12 bg-gray2" }, [
      _c("div", { staticClass: "h4 mb-0" }, [
        _vm._v("\n            " + _vm._s(_vm.dto.title) + "\n        "),
      ]),
      _vm._v(" "),
      _vm.dto.subTitleText
        ? _c("p", {
            directives: [
              {
                name: "safe-html",
                rawName: "v-safe-html",
                value: _vm.dto.subTitleText,
                expression: "dto.subTitleText",
              },
            ],
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.dto.items, function (item, itemIndex) {
          return _c(
            "div",
            {
              key:
                item && item.name
                  ? item.name
                  : `CrossSellMobileOfferTile-${itemIndex}`,
              staticClass: "my-1 col-11 col-sm-8 col-md-6 col-lg-5 col-xl-4",
            },
            [
              _c("MobileOfferTile", {
                attrs: { offer: item, "selected-mobile-offer-seo-id": "none" },
                on: {
                  "select-offer": function ($event) {
                    return _vm.addMobileOfferInCart($event, item)
                  },
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _vm.dto.otherOffersLink
      ? _c("div", { staticClass: "col-auto mb-1" }, [
          _c("a", {
            staticClass: "ob1-link-arrow",
            attrs: {
              href: _vm.dto.otherOffersLink.url,
              "data-oevent-category": _vm.dto.otherOffersLink.tms.category,
              "data-oevent-action": _vm.dto.otherOffersLink.tms.action,
              "data-oevent-label": _vm.dto.otherOffersLink.tms.label,
            },
            domProps: { textContent: _vm._s(_vm.dto.otherOffersLink.label) },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }